import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";

// components
import CustomSwitch from "../customSwitch/CustomSwitch";
import {DragDropList} from "../draggableList/DragDropList";

// utils
import {getStateByPath} from "../../redux/selectors";

// actions
import {genericIndexedActions} from "../../redux/actions/generics/GenericIndexedActions";

// css
import '../../../src/assets/css/Categorizer.css'


const Categorizer = ( props ) => {
    const {
        items = [],
        grouper,
        service,
        renderContent,
        loading = true
    } = props

    const path = `${props.path}`;
    const [groperItems, setGroperItems] = useState([])
    const [clickedItem, setClickedItem] = useState(0)
    const [filteredData, setFilteredData] = useState([])

    const roomTypeState = useSelector(state => getStateByPath(state, props.path));
    const {app} = roomTypeState?.data || {};

    useEffect(() => {
        if(items.length === 0)
            return

        setGroupedItems()
    }, [items]);

    useEffect(() => {
        if(groperItems.length === 0)
            return

        filterData(0)
    }, [groperItems]);

    const setGroupedItems = () => {
        const groupers = Object.values(items).map(item => item[grouper]);
        const uniqueArray = [...new Set(groupers)];

        setGroperItems(uniqueArray)
    }

    const filterData = (clickedItem) => {
        const data = items.filter(item => item[grouper] === groperItems[clickedItem])
        setFilteredData(data)
    }

    const onClick = (clickedKey) => {
        setClickedItem(clickedKey)
        filterData(clickedKey)
    }

    const onReorder = (itemsOrdered) => {
        const {list:reorderedItems} = itemsOrdered
        const items = []

        for (const reorderedItem of reorderedItems) {
            const {id, showOrder} = reorderedItem

            const item = filteredData.find(item => item.id === id)

            if(item?.showOrder !== showOrder)
                items.push({id, showOrder})
        }

        let requestData = {
            fbDataBase:  { id : app?.fbDataBase?.id },
            items
        }

        genericIndexedActions.reorder(path, service, requestData)
    }

    return <div className={'categorized-section'}>
        <div className={'categories'}>
            {
                groperItems.map((item, index) => (
                    <CustomSwitch
                        key={index}
                        label={item}
                        checked={index === clickedItem}
                        onClick={() => onClick(index)}
                    />
                ))
            }
        </div>
        <div className={'categorized-items'}>
            <DragDropList
                items={filteredData}
                renderContent={renderContent}
                onReorder={onReorder}
                loading={loading}
            />
        </div>
    </div>
}

export default Categorizer;